import type { OperationsDayResponse } from '@/shared/api';
import type { HeuteTodoAction } from './heuteTodoModel';

export interface Rule {
  tag: string;
  title: string;
  hot: boolean;
  /** Was der Zähler des Servers zählt, Einzahl und Mehrzahl. */
  unit: [string, string];
  action: (data: OperationsDayResponse, propertyIds: string[]) => HeuteTodoAction;
}

const cleaning = (data: OperationsDayResponse): HeuteTodoAction => ({
  kind: 'link',
  label: 'Zur Reinigung',
  to: '/cleaning',
  search: { date: data.date },
});
const publication = (data: OperationsDayResponse): HeuteTodoAction => ({
  kind: 'link',
  label: 'Zur Veröffentlichung',
  to: `/property-groups/${data.propertyGroupId}/veroeffentlichung`,
});
const inbox = (): HeuteTodoAction => ({ kind: 'link', label: 'Zu den Nachrichten', to: '/inbox' });
const quarantine = (): HeuteTodoAction => ({
  kind: 'link',
  label: 'Ansehen',
  to: '/bookings/quarantine',
});

const TASKS: [string, string] = ['Aufgabe', 'Aufgaben'];
const BOOKINGS: [string, string] = ['Buchung', 'Buchungen'];
const PUSHES: [string, string] = ['Übertragung', 'Übertragungen'];
const THREADS: [string, string] = ['Unterhaltung', 'Unterhaltungen'];

function rule(
  tag: string,
  title: string,
  hot: boolean,
  unit: [string, string],
  action: Rule['action'],
): Rule {
  return { tag, title, hot, unit, action };
}

/** Die Hinweise des Servers (OperationsAttentionCodes), in der Reihenfolge ihrer Dringlichkeit. */
export const RULES: Record<string, Rule> = {
  arrival_at_risk: {
    tag: 'Anreise',
    title: 'Anreise gefährdet',
    hot: true,
    unit: ['Anreise', 'Anreisen'],
    action: (_, ids) =>
      ids.length === 1
        ? { kind: 'apartment', label: 'Tagesdetails öffnen', propertyId: ids[0] as string }
        : { kind: 'link', label: 'Zu den Buchungen', to: '/bookings' },
  },
  cleaning_overdue: rule('Reinigung', 'Reinigung überfällig', true, TASKS, cleaning),
  cleaning_issue: rule('Reinigung', 'Offene Reinigungsmeldung', true, TASKS, cleaning),
  missing_turnover_task: rule(
    'Reinigung',
    'Reinigung beim Gästewechsel fehlt',
    true,
    ['Wechsel', 'Wechsel'],
    cleaning,
  ),
  cleaning_unassigned: rule('Reinigung', 'Reinigung nicht zugewiesen', true, TASKS, cleaning),
  ota_booking_quarantined: rule(
    'Buchungen',
    'Kanalbuchungen ohne Apartment',
    true,
    BOOKINGS,
    quarantine,
  ),
  channel_failed: rule('Kanal', 'Übertragung fehlgeschlagen', true, PUSHES, publication),
  inbox_reply_open: rule('Nachrichten', 'Nicht beantwortet', false, THREADS, inbox),
  inbox_unread: rule('Nachrichten', 'Ungelesene Nachrichten', false, THREADS, inbox),
  ota_booking_awaiting_route: rule(
    'Buchungen',
    'Kanalbuchungen warten auf Zuordnung',
    false,
    BOOKINGS,
    quarantine,
  ),
  channel_retry_scheduled: rule('Kanal', 'Übertragung wird wiederholt', false, PUSHES, publication),
};
